import Lenis from '@studio-freight/lenis'

export function commonFunc() {

  //パララックス
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // フェードイン
  const scrollElements = document.querySelectorAll(".js-fadeIn, .js-fade");

  const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop <=
      (window.innerHeight - '100' || document.documentElement.clientHeight) / dividend
    );
  };

  const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
  };

  const displayScrollElement = (element) => {

    element.classList.add("scrolled");
  };

  const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
  };

  const handleScrollAnimation = () => {
    scrollElements.forEach((el) => {
      if (elementInView(el, 1)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el)
      }
    })
  }

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  window.addEventListener("load", () => {
    handleScrollAnimation();
  });

  // ヘッダーのロゴの切り替え
  const header = document.querySelector('.l-header');
  const targetElement = document.querySelector('.js-header-black');
  const logo = document.getElementById('logo');
  
  function updateHeaderOnScrollOrLoad() {
    if (targetElement) {
      const targetTop = targetElement.getBoundingClientRect().top;
      const targetBottom = targetElement.getBoundingClientRect().bottom;
  
      // Check if the top of the target element is at the top of the viewport
      if (targetTop <= 0 && targetBottom > 0) {
        header.classList.add('black');
        logo.src = `${templateDirectoryUri}/img/logo-black.png`;
      } else {
        header.classList.remove('black');
        logo.src = `${templateDirectoryUri}/img/logo.png`;
      }
    }
  }
  
  window.addEventListener('scroll', updateHeaderOnScrollOrLoad);
  window.addEventListener('load', updateHeaderOnScrollOrLoad);
}